export default {
  font: {
    size: '16px',
    family: '"Fira Sans", sans-serif',
    url: 'https://fonts.googleapis.com/css?family=Fira+Sans:300,300i,400,400i,500,500i,600,600i,700,700i&display=swap',
  },
  focus: {
    color: 'palette.primary',
  },
  background: {
    color: 'palette.background',
  },
};
